import React from 'react';
import styled from 'styled-components';

import Section from '../components/section';
import { Link, Title } from '../components/text';
import { stylesFor } from '../styles/utilities';

const Root = styled(Section)`
  && {
    position: relative;

    // Switch to side-by-side layout.
    ${stylesFor.largeUp`
      align-items: center;
      display: flex;
      flex-direction: row-reverse;
      height: 55vw;
      max-height: 1000px;
    `};
  }
`;

const Content = styled.div`
  padding-bottom: 75vw;

  ${stylesFor.largeUp`
    flex-basis: 33.333%;
    padding-bottom: 0;
  `};
`;

const Details = styled.p`
  color: ${props => props.theme.color.gray19};
  font-size: 16px;
  line-height: 1.5;
  margin: 0 0 20px 0;
  padding: 0;

  ${stylesFor.largeUp`
    margin-bottom: 40px;
  `};
`;

const Download = styled.div`
  margin-top: 40px;

  ${stylesFor.largeUp`
    margin-top: 60px;
  `};
`;

export default () => {
  return (
    <Root
      style={{
        backgroundSize: 'contain',
        backgroundColor: '#f9f9f9',
        backgroundImage: `url('images/devices.png?v=1')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'bottom left',
      }}
    >
      <Content>
        <Title>Fits all sizes and devices</Title>
        <Details>
          SharePoint web parts are designed to work seamlessly on any page
          layout, screen size and to work great on mobile phones.
        </Details>
        <Link href="https://docs.microsoft.com/en-us/sharepoint/dev/design/grid-and-responsive-design">
          Learn more about responsive design
        </Link>
        <Download>
          <Details>Download the SharePoint mobile app.</Details>
          <Link href="https://itunes.apple.com/us/app/microsoft-sharepoint/id1091505266">
            iOS
          </Link>
          <Link
            href="https://play.google.com/store/apps/details?id=com.microsoft.sharepoint&hl=en"
            style={{ marginLeft: '40px' }}
          >
            Android
          </Link>
        </Download>
      </Content>
    </Root>
  );
};



// WEBPACK FOOTER //
// ./src/sections/devices.js